export const SHOW_QUOTA_PAYWALL = 'SHOW_QUOTA_PAYWALL';
export const HIDE_QUOTA_PAYWALL = 'HIDE_QUOTA_PAYWALL';
